import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Grafo } from "../../../shared/components/Grafo/Grafo"
import { Section } from "../../../shared/components/Section/Section"

export const GraphSection = () => {
    const { t }: any = useTranslation()
    const [isMobile, setIsMobile] = useState(
        window.matchMedia('(max-width: 768px)').matches
    )
    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)')
        const handleChange = (e: any) => setIsMobile(e.matches)

        mediaQuery.addEventListener('change', handleChange)
        return () => mediaQuery.removeEventListener('change', handleChange)
    }, [])
    return (
        <>
            <Section
                headerConfig={{
                    title: t('graph.title'),
                    description: t('graph.description'),
                    inLine: !isMobile,
                    maxWidth: '100%',
                }}
            >
                <div style={{ height: '800px' }}>
                    <Grafo></Grafo>
                </div>
            </Section>
        </>
    )
}

export default GraphSection